<template>
  <q-page class="main-wrapper-page single-page" style="background-color: var(--q-accent)">
    <section v-if="loadData" class="widget-section q-mb-lg">
      <EnvRegistration
        :registrationId="registrationId"
        :registrationData="registrationData"
        :envs="envs"
        :existEnvironments="environments"
        mode="edit"
      />
    </section>
    <section v-if="loadData" class="widget-section">
      <q-banner v-if="!environments.length" rounded style="min-height: 40px" class="bg-info text-white q-mb-md">
        Please register environment for Zones creation.
      </q-banner>
      <div class="flex items-center">
        <span class="label-block">Zones:</span>
        <q-btn
          @click="showForm"
          flat
          no-caps
          class="q-ml-auto btn--no-hover text-weight-regular"
          round
          color="light-blue-5"
          size="15px"
          style="min-height: 30px"
          :ripple="false"
          :disable="Boolean(createZoneError?.length)"
        >
          <q-tooltip v-if="createZoneError?.length">{{ createZoneError }}</q-tooltip>
          + Add Zone
        </q-btn>
      </div>
      <div v-if="showCreateForm">
        <div class="update-form">
          <q-banner
            v-for="(message, key) in prevalMessages"
            :key="`preval-${key}`"
            class="text-white q-mb-sm"
            :class="bannerClass(message.severity)"
          >
            <span class="flex items-center">
              <q-icon :name="message.severity === 'warning' ? 'warning' : 'info'" class="q-mr-xs" size="16px"></q-icon>
              {{ message.message }}
            </span>
          </q-banner>
          <q-banner v-if="generalErrors.length" class="text-white approval-error-banner q-mb-sm">
            <span class="flex items-center" v-for="(error, key) in generalErrors" :key="key">
              <q-icon name="error" class="q-mr-xs" size="16px"></q-icon>{{ error.message }}
            </span>
          </q-banner>
          <div class="flex full-width no-wrap">
            <JsonForms
              :renderers="renderers"
              :schema="schema"
              :data="formData"
              :uischema="uiSchema"
              :additionalErrors="createErrors"
              validationMode="ValidateAndShow"
              @change="validateForm"
            />
            <q-btn
              color="primary"
              size="md"
              class="q-ml-sm"
              :loading="loadSend"
              :disable="
                loadSend ||
                submitDisable ||
                Boolean(formErrors.length) ||
                Boolean(createErrors.length) ||
                Boolean(generalErrors.length)
              "
              style="height: 38px"
              @click="sendData()"
              no-caps
              label="Submit"
            ></q-btn>

            <q-btn flat size="md" class="btn--no-hover" style="height: 40px" no-caps @click="closeForm">Cancel</q-btn>
          </div>
        </div>
      </div>
      <ZonesWidget
        :registrationData="registrationData"
        :registrationId="registrationId"
        mode="edit"
        :expanded="expanded"
        @toggleExpanded="toggleExpanded($event)"
        @confirmDeleteZone="confirmDeleteZone"
        @reassign="openReassignDialog"
      >
        <template #expand>
          <q-td colspan="100%" class="update-form-cell">
            <q-banner v-if="generalErrors.length" class="text-white approval-error-banner">
              <span class="flex items-center" v-for="(error, key) in generalErrors" :key="key">
                <q-icon name="error" class="q-mr-xs" size="16px"></q-icon>{{ error.message }}
              </span>
            </q-banner>
            <div class="flex full-width no-wrap update-form q-pb-sm q-pt-sm">
              <JsonForms
                :renderers="renderers"
                :schema="updateSchema"
                :data="formData"
                :uischema="updateUiSchema"
                :additionalErrors="createErrors"
                validationMode="ValidateAndShow"
                @change="validateForm"
              />
              <q-btn
                color="primary"
                size="md"
                class="q-ml-sm"
                :loading="loadSend"
                :disable="
                  loadSend ||
                  submitDisable ||
                  Boolean(formErrors.length) ||
                  Boolean(createErrors.length) ||
                  Boolean(generalErrors.length)
                "
                style="height: 38px"
                @click="sendData()"
                no-caps
                label="Submit"
              ></q-btn>

              <q-btn flat size="md" class="btn--no-hover" style="height: 40px" no-caps @click="closeForm">Cancel</q-btn>
            </div>
          </q-td>
        </template>
      </ZonesWidget>
    </section>

    <q-dialog v-model="deleteZoneConfirm" class="single-service-page" persistent>
      <q-card style="min-width: 768px; border-radius: 0px">
        <q-toolbar class="shadow-2 q-py-sm q-px-md">
          <q-toolbar-title class="text-weight-bold">
            <strong>Confirm Delete Zone</strong>
          </q-toolbar-title>
          <q-btn icon="close" round flat class="btn--no-hover" @click="deleteZoneConfirm = false"></q-btn>
        </q-toolbar>
        <q-card-section>
          <q-banner
            v-for="(message, key) in deleteZoneMessages"
            :key="`delete-message-${key}`"
            class="text-white q-mb-md"
            :class="bannerClass(message.severity)"
          >
            <span class="flex items-center">
              <q-icon :name="message.severity === 'warning' ? 'warning' : 'info'" class="q-mr-xs" size="16px"></q-icon>
              {{ message.message }}
            </span>
          </q-banner>
          <p>
            After zone will be deleted from Cloudflare, a ticket for <b>IAM</b> team will be created, on your behalf, to
            remove zone's access products.
          </p>
        </q-card-section>
        <q-card-actions class="q-pb-md">
          <q-btn
            color="primary"
            size="md"
            class="q-ml-sm"
            @click="deleteZone"
            :loading="deleteLoading"
            :disabled="deleteLoading"
            no-caps
            label="Yes"
          ></q-btn>
          <q-btn flat size="md" class="btn--no-hover" style="height: 40px" no-caps @click="deleteZoneConfirm = false"
            >No</q-btn
          >
        </q-card-actions>
      </q-card>
    </q-dialog>

    <ReassignDialog
      :showReassignDialog="showReassignDialog"
      entity="zone"
      :newDigitalService="newDigitalService"
      :loading="loadReassign"
      :errors="reassignErrors"
      @submit="sendReassignRequest"
      @cancel="closeReassignDialog"
      @resetService="resetDigitalService"
      @setService="setDigitalService"
    />
  </q-page>
</template>

<script>
import { JsonForms } from '@jsonforms/vue';
import emitter from 'tiny-emitter/instance';
import {
  getRegistration,
  getBluePrint,
  validateWorkFlow,
  createWorkFlow,
  subValWorkflow,
  extractPrevalMessages,
} from '../../api/api';
import { quasarRenderers } from '@/shared/jsonformsQuasarRenderers/renderers';
import EnvRegistration from '../EnvRegistration.vue';
import ReassignDialog from '../ReassignDialog.vue';
import ZonesWidget from '@/pages/digitalService/components/cloudente/ZonesWidget.vue';

const renderers = [...quasarRenderers];

export default {
  name: 'RegistrationCloudente',
  components: {
    JsonForms,
    ZonesWidget,
    EnvRegistration,
    ReassignDialog,
  },
  props: {
    registrationId: {
      type: String,
    },
    registrationData: {
      type: Object,
    },
  },
  data() {
    return {
      envs: ['PROD'],
      environments: [],
      createZoneError: undefined,
      deleteZoneConfirm: false,
      loadData: false,
      showCreateForm: false,
      formErrors: [],
      createErrors: [],
      generalErrors: [],
      prevalMessages: [],
      loadSend: false,
      submitDisable: true,
      renderers: Object.freeze(renderers),
      validationTimeout: undefined,
      currentZone: undefined,
      deleteZoneMessages: [],
      formData: {
        digitalServiceApmId: this.registrationData.digitalServiceApm,
      },
      schema: {},
      uiSchema: {
        type: 'Group',
        elements: [
          {
            type: 'HorizontalLayout',
            elements: [
              {
                type: 'Control',
                label: 'Zone name',
                scope: '#/properties/zone_name',
              },
              {
                type: 'Control',
                label: 'License',
                scope: '#/properties/license',
              },
              {
                type: 'Control',
                label: 'DNS delegation',
                scope: '#/properties/dns',
                class: 'col-3',
                options: {
                  linkToDocs: 'https://wiki.swissre.com/pages/viewpage.action?pageId=799310884',
                  tooltip:
                    'Enabled. If your zone is "{something}.swissre.com" AND it is NEW (never existed before). This will create proper NS records in Cloudflare swissre.com zone, so your zone will be immediately enabled and accessible. ',
                },
              },
            ],
          },
          {
            type: 'HorizontalLayout',
            elements: [
              {
                type: 'Control',
                label: 'Custom Implementation schedule',
                scope: '#/properties/changeDetails/properties/enableDates',
                class: 'col-3',
              },
              {
                type: 'CustomDateControl',
                label: 'Start date',
                scope: '#/properties/changeDetails/properties/startDate',
                class: 'col-3',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: '#/properties/changeDetails/properties/enableDates',
                    schema: {
                      const: true,
                    },
                  },
                },
              },
              {
                type: 'CustomDateControl',
                label: 'End date',
                scope: '#/properties/changeDetails/properties/endDate',
                class: 'col-3',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: '#/properties/changeDetails/properties/enableDates',
                    schema: {
                      const: true,
                    },
                  },
                },
              },
            ],
          },
          {
            type: 'Group',
            label: 'Questionary',
            elements: [
              {
                type: 'Control',
                label: 'Answer 1',
                scope: '#/properties/questionary/properties/question1',
                options: {
                  description: `1. In case you require a new (sub)domain, state the purpose and the need. 
                                What would it be used for? For which business unit/department is this request if any? For example,
                                is it a new digital tool launch for Corporate Solutions? Or a new website for a new tool or platform? 
                                Or is it a platform to support an already existing product? etc.`,
                },
              },
              {
                type: 'Control',
                label: 'Answer 2',
                scope: '#/properties/questionary/properties/question2',
                options: {
                  description: `2. Who will be using this (sub)domain? Please specify the target audience (job roles, industries, or geographical regions).`,
                },
              },
              {
                type: 'Control',
                label: 'Answer 3',
                scope: '#/properties/questionary/properties/question3',
                options: {
                  description: `3. How will users find and access this (sub)domain? Please specify the platforms or channels (e.g., social media, email, other websites, 
                                client managers) that will be used to promote it, if any.`,
                },
              },
            ],
          },
        ],
      },
      workFlowAction: undefined,
      expanded: [],
      updateSchema: {},
      updateUiSchema: {
        type: 'Group',
        elements: [
          {
            type: 'HorizontalLayout',
            elements: [
              {
                type: 'Control',
                label: 'Zone name',
                scope: '#/properties/zone_name',
              },
              {
                type: 'Control',
                label: 'License',
                scope: '#/properties/license',
                options: {
                  editable: true,
                },
              },
            ],
          },
          {
            type: 'HorizontalLayout',
            elements: [
              {
                type: 'Control',
                label: 'Custom Implementation schedule',
                scope: '#/properties/changeDetails/properties/enableDates',
                class: 'col-3',
              },
              {
                type: 'CustomDateControl',
                label: 'Start date',
                scope: '#/properties/changeDetails/properties/startDate',
                class: 'col-3',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: '#/properties/changeDetails/properties/enableDates',
                    schema: {
                      const: true,
                    },
                  },
                },
              },
              {
                type: 'CustomDateControl',
                label: 'End date',
                scope: '#/properties/changeDetails/properties/endDate',
                class: 'col-3',
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: '#/properties/changeDetails/properties/enableDates',
                    schema: {
                      const: true,
                    },
                  },
                },
              },
            ],
          },
        ],
      },
      showReassignDialog: false,
      newDigitalService: undefined,
      loadReassign: false,
      reassignErrors: undefined,
      deleteLoading: false,
    };
  },
  methods: {
    bannerClass(severity) {
      return severity === 'warning' ? 'bg-orange-8' : 'bg-info';
    },
    async sendReassignRequest() {
      this.loadReassign = true;
      const data = {
        workflowId: 'engprt.move-cloudflare-zone',
        inputVariables: {
          digitalServiceApmId: this.newDigitalService.apmId,
          license: this.currentZone.license,
          dns: false,
          zone_name: this.currentZone.zone_name,
          zoneReassignment: {
            id: this.currentZone.id,
          },
        },
      };
      createWorkFlow(data)
        .then(() => {
          this.$notify('positive', 'Success', `Zone will be reassign to ${this.newDigitalService.digitalServiceName}.`);
          emitter.emit('reloadZones');
        })
        .catch((error) => {
          this.$notify('negative', 'Error', error.message);
        })
        .finally(() => {
          this.closeReassignDialog();
        });
    },
    resetDigitalService() {
      this.newDigitalService = undefined;
      this.reassignErrors = undefined;
    },
    async setDigitalService(service) {
      this.reassignErrors = undefined;
      this.loadReassign = true;
      this.newDigitalService = service;
      const data = {
        workflowId: 'engprt.move-cloudflare-zone',
        inputVariables: {
          digitalServiceApmId: this.newDigitalService.apmId,
          license: this.currentZone.license,
          dns: false,
          zone_name: this.currentZone.zone_name,
          zoneReassignment: {
            id: this.currentZone.id,
          },
        },
      };
      validateWorkFlow(data)
        .then(() => {
          this.reassignErrors = undefined;
        })
        .catch((error) => {
          this.reassignErrors = error.message;
        })
        .finally(() => {
          this.loadReassign = false;
        });
    },
    closeReassignDialog() {
      this.newDigitalService = undefined;
      this.currentZone = undefined;
      this.showReassignDialog = false;
      this.reassignErrors = undefined;
    },
    openReassignDialog(zone) {
      this.currentZone = zone;
      this.showReassignDialog = true;
    },
    async validateForm(value) {
      if (value.data?.changeDetails?.enableDates === false) {
        delete value.data.changeDetails.startDate;
        delete value.data.changeDetails.endDate;
      }
      if (value.data?.changeDetails?.startDate && value.data?.changeDetails?.endDate) {
        if (new Date(value.data?.changeDetails?.startDate) > new Date(value.data?.changeDetails?.endDate)) {
          const newError = {
            instancePath: '/changeDetails/endDate',
            message: 'End date must be later than start date.',
            schemaPath: '',
            keyword: '',
            params: {},
          };
          if (!this.createErrors.find((e) => e.instancePath === '/changeDetails/endDate')) {
            this.createErrors.push(newError);
          }
        } else {
          const index = this.createErrors.find((e) => e.instancePath === '/changeDetails/endDate');
          this.createErrors.splice(index, 1);
        }
      }
      if (!value.data?.changeDetails?.enableDates) {
        if (value.data?.changeDetails) {
          delete value.data.changeDetails.startDate;
          delete value.data.changeDetails.endDate;
        }
      }
      this.formData = value.data;
      this.formErrors = value.errors;
      if (!value.errors.length && !this.createErrors.length) {
        this.loadSend = true;
        if (this.validationTimeout) clearTimeout(this.validationTimeout);
        this.validationTimeout = setTimeout(async () => {
          const workflowData = {
            workflowId: this.workFlowAction,
            inputVariables: this.buildInputVariables(),
          };
          try {
            const response = await validateWorkFlow(workflowData);
            if (this.createErrors.length) {
              this.createErrors = [];
            }

            this.generalErrors = [];
            this.prevalMessages = extractPrevalMessages(response);
            this.submitDisable = false;
          } catch (error) {
            this.prevalMessages = [];
            if (error?.response?.data?.errors?.length) {
              //this.createErrors = error.response.data.errors.filter((error) => error.instancePath.length);
              this.generalErrors =
                error.response.data.errors.filter((error) => !error.instancePath.length && error.params?.toDisplay) ||
                [];
            } else {
              this.$notify('negative', 'Error', error.message);
              if (this.createErrors.length) {
                this.createErrors = [];
              }
              this.generalErrors = [];
              clearTimeout(this.validationTimeout);
            }
          } finally {
            this.loadSend = false;
          }
        }, 3000);
      }
    },
    buildInputVariables() {
      if (this.workFlowAction === 'engprt.update-cloudflare-zone') {
        const { digitalServiceApmId, id, license, changeDetails } = this.formData;
        return { digitalServiceApmId, id, newLicense: license, changeDetails };
      }
      return this.formData;
    },
    toggleExpanded(zone) {
      this.formErrors = [];
      this.createErrors = [];
      this.generalErrors = [];
      this.showCreateForm = false;
      this.workFlowAction = 'engprt.update-cloudflare-zone';
      this.formData = {
        digitalServiceApmId: this.registrationData.digitalServiceApm,
        id: zone.id,
        zone_name: zone.zone_name,
        license: zone.license,
        changeDetails: { enableDates: false },
      };
      this.expanded = this.expanded[0] === zone.id ? [] : [zone.id];
    },
    closeForm() {
      if (this.validationTimeout) clearTimeout(this.validationTimeout);
      this.formData = { digitalServiceApmId: this.registrationData.digitalServiceApm };
      this.prevalMessages = [];
      this.showCreateForm = false;
      this.expanded = [];
      this.formErrors = [];
      this.createErrors = [];
      this.generalErrors = [];
      this.submitDisable = true;
    },
    async confirmDeleteZone(zone) {
      this.currentZone = zone;
      const deleteZoneWorkflow = {
        workflowId: 'engprt.delete-cloudflare-zone',
        inputVariables: {
          digitalServiceApmId: this.registrationData.digitalServiceApm,
          id: zone.id,
        },
      };
      try {
        const response = await validateWorkFlow(deleteZoneWorkflow);
        this.deleteZoneMessages = extractPrevalMessages(response);
        this.deleteZoneConfirm = true;
      } catch (error) {
        this.deleteZoneMessages = [];
        this.$notify('negative', 'Error', error.message);
        this.currentZone = undefined;
      }
    },
    async deleteZone() {
      this.deleteLoading = true;
      const deleteZoneWorkflow = {
        workflowId: 'engprt.delete-cloudflare-zone',
        inputVariables: {
          digitalServiceApmId: this.registrationData.digitalServiceApm,
          id: this.currentZone.id,
        },
      };
      try {
        await createWorkFlow(deleteZoneWorkflow);
        this.$notify('positive', 'Success', 'Zone will be deleted.');
        emitter.emit('reloadZones');
        emitter.emit('reloadEnvironments');
      } catch (error) {
        this.$notify('negative', 'Error', error.message);
      } finally {
        this.deleteLoading = false;
        this.currentZone = undefined;
        this.deleteZoneMessages = [];
        this.deleteZoneConfirm = false;
      }
    },
    async sendData() {
      try {
        const workflowData = {
          workflowId: this.workFlowAction,
          inputVariables: this.buildInputVariables(),
        };

        this.loadSend = true;
        await createWorkFlow(workflowData);
        this.$notify(
          'positive',
          'Success',
          `Zone will be ${this.workFlowAction === 'engprt.create-cloudflare-zone' ? 'created' : 'updated'}.`,
        );
        emitter.emit('reloadZones');
        emitter.emit('reloadEnvironments');
        this.closeForm();
      } catch (error) {
        this.$notify('negative', 'Error', error.message);
      } finally {
        this.loadSend = false;
      }
    },
    showForm() {
      this.workFlowAction = 'engprt.create-cloudflare-zone';
      this.closeForm();
      this.showCreateForm = true;
    },
  },
  async mounted() {
    const { inputVariablesSchema: schema } = await getBluePrint('engprt.create-cloudflare-zone');
    delete schema.$async;
    delete schema.$schema;
    this.schema = schema;
    const { inputVariablesSchema: updateSchema } = await getBluePrint('engprt.update-cloudflare-zone');
    delete updateSchema.$async;
    delete updateSchema.$schema;
    this.updateSchema = updateSchema;
    this.loadData = false;
    this.$showLoading();
    try {
      const dataPromise = getRegistration(this.registrationId, true, false).then(async (response) => {
        this.environments = response.environments.map((env) => ({ status: env.status, value: env.value, id: env.id }));
      });
      const subvalCreateZone = {
        workflowId: 'engprt.create-cloudflare-zone',
        inputVariables: {
          digitalServiceApmId: this.registrationData.digitalServiceApm,
        },
        subSchemaId: 'add-button',
      };
      const subValPromise = subValWorkflow(subvalCreateZone)
        .then(() => {
          this.createZoneError = undefined;
        })
        .catch((error) => {
          this.createZoneError = error.message;
        });
      await Promise.all([dataPromise, subValPromise]);
    } catch (error) {
      this.$notify('negative', 'Error', error.message);
    } finally {
      this.loadData = true;
      this.$hideLoading();
    }
  },
};
</script>

<style lang="scss">
.update-form-cell {
  .q-banner {
    min-height: 38px;
    margin-bottom: 5px;
  }
}
.update-form {
  .q-field__bottom {
    padding: 3px 0 0 3px;
    white-space: pre;
  }
}
</style>
<style lang="scss" scoped>
.env-form {
  width: 50%;
}
.label-block {
  font-size: 20px;
}
.widget-section {
  border-radius: 15px;
  background-color: white;
  padding: 30px;
}
</style>
